import { Fragment, type FunctionComponent } from "react";
import { PhotoUpload } from "./PhotoUpload";
import type { UploadQueue } from "./useUploadPhotoHandler";

interface Props {
    queue: UploadQueue;
}

export const UploadQueueRender: FunctionComponent<Props> = ({ queue }) => {
    return (
        <Fragment>
            {Object.entries(queue).map(([key, value]) => (
                <PhotoUpload key={`upload-${key}`} {...value} />
            ))}
        </Fragment>
    );
};
